module.exports = __webpack_public_path__ + "static/media/flag.933cdc43.svg";